import React from 'react';
import { registerWidget } from '@okapi/core';
import { getGlobalRouter } from '@okapi/router-react';
import { FETCH_COLLECTIONS, ResponseCollectionList } from 'modules/collections';
import { FETCH_RELATED_SERVICES } from 'modules/related-services';
import { State } from 'store/types';
import { BathroomCollectionsRemote } from '../../common/widgets';
import { initWidgetData } from '../init-widget-data';

registerWidget<State, Record<string, string>>(`${__NAME__}/bathroom-collections`, state => {
  const router = getGlobalRouter();
  const store = initWidgetData(state);
  if ('collectionList' in state.collections) {
    const collectionState = {
      collectionList: state.collections.collectionList,
      offset: state.collections.offset,
      productsCount: state.collections.productsCount,
      facets: state.collections.facets,
    } as ResponseCollectionList;

    store.dispatch(FETCH_COLLECTIONS.success, collectionState);
  }
  store.dispatch(FETCH_RELATED_SERVICES.success, state.relatedServices?.serviceList ?? undefined);

  return remoteProps => <BathroomCollectionsRemote router={router} store={store} {...remoteProps} />;
});
